export class Box {
  public name?: string;
  public menu?: string;
  public title?: string;
  public hideFromPersonalDashboard?: string;
  public icon?: string;
  public whiteIcon?: string;
  public backgroundColor?: string;
  public iconColor?: string;
  public click?: () => void;
  public count?: number;
  public hide?: boolean;
  public index?: number;
  public id?: number;

  constructor(data?: Box) {
    for (const i in data) {
      this[i] = data[i];
    }
    this.count = data.count;
  }
}
